import { render } from "./piggy-bank.vue?vue&type=template&id=850f7fa4"
import script from "./piggy-bank.vue?vue&type=script&lang=js"
export * from "./piggy-bank.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__